<template lang="pug">
    
div(
    id="app"
    :class="styles.root"
)
    div(
        :class="styles.container"
    )
        TransitionFade
            div(
                v-if="state.kind === 'loading'"
                key="loader"
                :class="styles.wrapper"
            )
                Loader
            div(
                v-else
                key="content"
                :class="styles.wrapper"
            )
                AnimatedHeightTransition
                    div(
                        :key="state.kind !== 'expired'"
                        :class="styles['wrapper-animation']"
                    )
                        Header(
                            v-if="state.merchant && state.kind !== 'expired' && !state.removeHeader"
                            :class="styles.header"
                        )
                        Content(
                            :class="styles.content"
                        )
        Footer(
            :class="styles.footer"
        )
    Debug(
        v-if="debugState.isShow"
    )
    QrForDownload(
        id="qr-share"
    )

</template>

<script lang="ts">
import Vue, { onBeforeUnmount, onMounted, useCssModule, watch } from 'vue'

import { useAppModel } from '@/app/model'
import { useDebug } from '@/app/Debug'

import { Header } from '@/widgets/Header'
import { Footer } from '@/widgets/Footer'
import { Loader } from '@/widgets/Loader'
import { useAutoHeight } from '@/widgets/Header/useAutoHeight'
import { QrForDownload } from '@/widgets/QrForDownload'

import { radiusModel, useTheme } from '@/shared/lib/model'
import { useAppStore } from '@/shared/model'
import { TransitionFade } from '@/shared/ui/transitions/TransitionFade'
import { AnimatedHeightTransition } from '@/shared/ui/transitions/AnimatedHeightTransition'
// import { analytics } from '@/shared/lib/analytics'
import { yandexMetrica } from '@/shared/lib/yandex-metrica'

import { Content } from './Content'

import { useSendSessionTime } from '@/feature/send-session-time'

export default Vue.extend({
    name: 'App',
    setup() {
        const styles = useCssModule()
        useAppModel()
        useSendSessionTime()
        const { state, analyticsData } = useAppStore()
        const hooks = useAutoHeight()

        useTheme()
        radiusModel.setRadius('soft')

        const { state: debugState } = useDebug()

        // analytics.init()

        watch(analyticsData, data => {
            // analytics.sendEvent({
            //     name: 'Create Payment Link',
            //     properties: {
            //         link: window.location.href,
            //         qrData: data.value,
            //     },
            // })
            yandexMetrica.sendEvent({
                name: 'Create Payment Link',
                properties: {
                    link: window.location.href,
                    qrData: data.value,
                },
            })
        })

        function onHashChange() {
            location.reload()
        }

        onMounted(() => {
            window.addEventListener('hashchange', onHashChange)
        })

        onBeforeUnmount(() => {
            window.removeEventListener('hashchange', onHashChange)
        })

        return {
            styles,
            state,
            debugState,
            ...hooks,
            analyticsData,
        }
    },
    components: {
        QrForDownload,
        Loader,
        TransitionFade,
        Header,
        Content,
        Footer,
        AnimatedHeightTransition,
        Debug: () => import(/* webpackChunkName: "aapp" */ './Debug/Debug.vue'),
    },
})
</script>

<style lang="scss" src="./app.scss" />

<style lang="scss" module src="./app.module.scss" />
